import { RouterAction } from 'connected-react-router'
import { AccountPageAction } from 'scenes/Account/duck/actions'
import { ActionType, createAction } from 'typesafe-actions'

import { FlashNoticeAction } from '../components/FlashNotice/duck/actions'
import { DataAction } from '../data/actions'
import { DashboardAction } from '../scenes/Dashboard/duck/actions'

export type RootAction = ScenesAction | DataAction | ComponentsAction | GlobalActions | RouterActions

export type RouterActions = RouterAction

export type ActionCreator = (...args: any[]) => RootAction
export type PayloadActionCreated = (...args: any[]) => RootActionWithPayload
type RootActionWithPayload = { payload: any } & RootAction

type ScenesAction = DashboardAction | AccountPageAction
type ComponentsAction = FlashNoticeAction
type GlobalActions = ActionType<typeof appMounted>

export const appMounted = createAction('/APP_MOUNTED')
